// Selects the active repository from configuration. VITE_PB_URL is mandatory
// at build time (set in the shell before `npm run build`).

import type { Repository } from "./types";
import { PocketBaseRepository } from "./pocketbase";

export type { Repository, SessionUser } from "./types";

export function createRepository(): Repository {
  const url = (import.meta.env.VITE_PB_URL ?? "").trim();
  if (!url) {
    throw new Error(
      "VITE_PB_URL must be set at build time (e.g. VITE_PB_URL=https://arkhmedic.online npm run build)",
    );
  }
  return new PocketBaseRepository(url);
}
